import React, { useState } from "react";
import { Box, Flex } from "rebass";
import styled from "styled-components";
import { IToggleAllProps } from "../ToggleAll";
import { ReactComponent as AllHover } from "../../../../../assets/images/studio/select-all-hover.svg";
import { ReactComponent as AllStatic } from "../../../../../assets/images/studio/select-all-static.svg";
import { ReactComponent as NoneHover } from "../../../../../assets/images/studio/select-none-hover.svg";
import { ReactComponent as NoneStatic } from "../../../../../assets/images/studio/select-none-static.svg";

export const ToggleAllButton = ({
  handleToggleAll,
  cards,
  category,
}: IToggleAllProps) => {
  const [enableHovered, setEnableHovered] = useState(false);
  const [disableHovered, setDisableHovered] = useState(false);

  const EnableAll = () => {
    if (enableHovered) return <AllHover />;
    else return <AllStatic />;
  };
  const DisableAll = () => {
    if (disableHovered) return <NoneHover />;
    else return <NoneStatic />;
  };
  return (
    <>
      <Wrapper>
        {" "}
        {/* <Text>Enable</Text> */}
        <StyledBox
          onClick={() => {
            handleToggleAll(true, category, cards);
          }}
          onMouseEnter={() => {
            setEnableHovered(true);
          }}
          onMouseLeave={() => {
            setEnableHovered(false);
          }}
        >
          <EnableAll />
        </StyledBox>
        <StyledDivider />
        <StyledBox
          onClick={() => {
            handleToggleAll(false, category, cards);
          }}
          onMouseEnter={() => {
            setDisableHovered(true);
          }}
          onMouseLeave={() => {
            setDisableHovered(false);
          }}
        >
          <DisableAll />
        </StyledBox>
      </Wrapper>
    </>
  );
};

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  // padding-right: 13px;
  padding-left: 15px;
`;

// const Text = styled(Subheader)`
//   font-weight: 500;
//   margin-right: 8px;
// `;

const StyledDivider = styled.div`
  width: 2px;
  height: 25px;
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  background-color: ${(props) => {
    return props.theme.colors.navy;
  }};
`;

const StyledBox = styled(Box)`
  &:hover {
    cursor: pointer;
  }
`;
